import { FirstRunType } from '@office-start/first-run-types';
import { ConsumerSkuType } from '@office-start/officehome-types';
/**
 * Uses input arguments to group user into specific FirstRunType.
 */
export function calculateFirstRunType(userEntitlements, consumerSkuType, isPipl) {
    var IsAdmin = userEntitlements.IsAdmin, IsEdu = userEntitlements.IsEdu, IsEduStudent = userEntitlements.IsEduStudent, IsEduFaculty = userEntitlements.IsEduFaculty, ShowConsumerUpsell = userEntitlements.ShowConsumerUpsell;
    var isCommercial = consumerSkuType === ConsumerSkuType.NotDetected ||
        consumerSkuType === undefined;
    var isConsumerFree = consumerSkuType === ConsumerSkuType.NonActive ||
        consumerSkuType === ConsumerSkuType.NotSubscribed ||
        consumerSkuType === ConsumerSkuType.O365Basic;
    var isConsumerPaidIndividual = consumerSkuType === ConsumerSkuType.O365Personal ||
        consumerSkuType === ConsumerSkuType.O365Solo ||
        consumerSkuType === ConsumerSkuType.OtherSubscription ||
        consumerSkuType === ConsumerSkuType.Perpetual ||
        consumerSkuType === ConsumerSkuType.Perpetual2019;
    var isConsumerPaidFamily = consumerSkuType === ConsumerSkuType.O365Home ||
        consumerSkuType === ConsumerSkuType.O365HomeTrial;
    var isCommercialStandardUser = isCommercial && !IsAdmin;
    var isCommercialItAdmin = isCommercial && IsAdmin;
    var isEduStudent = IsEduStudent;
    var isEduFaculty = IsEduFaculty && !IsAdmin;
    var isEduItAdmin = IsEdu && IsAdmin;
    if (isConsumerFree) {
        if (!ShowConsumerUpsell || isPipl) {
            return FirstRunType.ConsumerFreeUpsellDisabled;
        }
        else {
            return FirstRunType.ConsumerFree;
        }
    }
    else if (isConsumerPaidIndividual) {
        return FirstRunType.ConsumerPaidIndividual;
    }
    else if (isConsumerPaidFamily) {
        return FirstRunType.ConsumerPaidFamily;
    }
    else if (isEduStudent) {
        return FirstRunType.EduStudent;
    }
    else if (isEduFaculty) {
        return FirstRunType.EduFaculty;
    }
    else if (isEduItAdmin) {
        return FirstRunType.EduItAdmin;
    }
    else if (isCommercialItAdmin) {
        return FirstRunType.CommercialItAdmin;
    }
    else if (isCommercialStandardUser) {
        return FirstRunType.CommercialStandardUser;
    }
    else {
        throw new Error('Invoked calculateFirstRunType, but FirstRunType not found');
    }
}
//# sourceMappingURL=calculateFirstRunType.js.map